import { createSelector } from '@reduxjs/toolkit';

export const isLoad = createSelector(
    (state) => state.app,
    app => app.load
);

export const getTheme = createSelector(
    (state) => state.app,
    app => app.theme
);

